// @flow

import {
  DOCUMENTS_FORM_CREATE,
  NEW_PATIENT_DOCUMENTS_FORM_CREATE,
  DOCUMENTS_FORM_CREATED,
  DOCUMENTS_FORM_CREATE_ERROR,
  DOCUMENTS_FORM_DELETE,
  DOCUMENTS_FORM_DELETED,
  DOCUMENTS_FORM_DELETE_ERROR,
  DOCUMENTS_FORM_UPDATE,
  DOCUMENTS_FORM_UPDATED,
  DOCUMENTS_FORM_UPDATE_ERROR
} from './constants';

import type { Action, ManipulateAttributes, ManipulatePatientAttributes } from '../types';

export const createDocument = (data: ManipulateAttributes): Action => ({
  type: DOCUMENTS_FORM_CREATE,
  data
});

export const newPatientCreateDocument = (newPatientData: ManipulatePatientAttributes): Action => ({
  type: NEW_PATIENT_DOCUMENTS_FORM_CREATE,
  newPatientData
});

export const createdDocument = (): Action => ({
  type: DOCUMENTS_FORM_CREATED
});

export const errorCreateDocument = (): Action => ({
  type: DOCUMENTS_FORM_CREATE_ERROR
});

export const deleteDocument = (id: string): Action => ({ type: DOCUMENTS_FORM_DELETE, id });
export const deletedDocument = (id: string): Action => ({ type: DOCUMENTS_FORM_DELETED, id });

export const errorDeleteDocument = (id: string): Action => ({
  type: DOCUMENTS_FORM_DELETE_ERROR,
  id
});

export const updateDocument = (id: string, data: ManipulateAttributes): Action => ({
  type: DOCUMENTS_FORM_UPDATE,
  id,
  data
});

export const updatedDocument = (id: string): Action => ({
  type: DOCUMENTS_FORM_UPDATED,
  id
});

export const errorUpdateDocument = (id: string): Action => ({
  type: DOCUMENTS_FORM_UPDATE_ERROR,
  id
});
